define(function(require, exports, module) {
    'use strict';

    const util = require('utils');
    const Class = require('Class');
    const AbstractProvider = require('common/addressLookupSwiss/sourceProviders/abstractProvider');

    module.exports = Class.create(AbstractProvider, {
        houseRegEx: /^[0-9]*$/,

        prepareRequest: function(searchText, prevSearchResult) {
            const data = AbstractProvider.prototype.prepareRequest(searchText, prevSearchResult);

            data.request = {
                ...data.request,
                HouseNumber: searchText,
                TownName: prevSearchResult.city,
                Streetname: prevSearchResult.streetName
            };

            return data;
        },

        format: function(row) {
            return this.highlightResult(row.houseNumber);
        },

        /**
         * @override
         */
        isValid: function(searchText) {
            return searchText.length >= 1 && this.houseRegEx.test(searchText);
        },

        sort: function(rows) {
            return rows.sort(function(row1, row2) {
                const num1 = parseInt(row1.houseNumber);
                const num2 = parseInt(row2.houseNumber);

                return -util.predicate.numberPredicate(num1, num2);
            });
        }
    });
});
